<template>
  <div>
    Display Folder Structure Fields Here...
  </div>
</template>

<script>
export default {
  name: 'FolderStructureIndexing',
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: { },
}
</script>

<style lang="scss" scoped>
</style>
